import React, { memo } from 'react';
// import { Polygon } from 'react-google-maps';
import { Polygon } from "@react-google-maps/api";


const DisplayPolygon = ({ geoBound }) => {

  const getPath = () => {
    if (geoBound.GeoPath) {
      return geoBound.GeoPath;
    }

    const polygonArray = geoBound.GeoBoundaryShape.split("((")[1].split(" ").join(",").split(",");
    polygonArray.pop();
    polygonArray.pop();

    const polyCoords = [];
    for (let i = 0; i < polygonArray.length; i = i + 2) {
      polyCoords.push({ lat: Number(polygonArray[i + 1]), lng: Number(polygonArray[i]) });
    }

    //console.log('polygonArray', polyCoords);
    return polyCoords;
  };

  return (
    <Polygon
      path={getPath()}
      options={{
        strokeColor: '#a576fb',
        strokeOpacity: 1.0,
        strokeWeight: 3,
        fillColor: "#d7a6fd",
        editable: false,
        draggable: false,
      }}
    />
  );
};

export default memo(DisplayPolygon);